import { EPipelineGroupSegment, EPipelineSegment, i18n } from '@progress-fe/core';
import { PipeLineSegmentIcon } from '../../../constants';
export const SEGMENT_ITEM_WIDTH = 240;
export const PIPELINE_SEGMENT_HEIGHT = '28px';
export const SEGMENT_TYPE_OPTIONS = [
    /** Соединительные элементы трубопроводов **/
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Pipe}`),
        value: EPipelineSegment.Pipe,
        icon: PipeLineSegmentIcon[EPipelineSegment.Pipe],
        group: EPipelineGroupSegment.Pipe
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.CouplingUnion}`),
        value: EPipelineSegment.CouplingUnion,
        icon: PipeLineSegmentIcon[EPipelineSegment.CouplingUnion],
        group: EPipelineGroupSegment.Pipe
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.TeeElbow}`),
        value: EPipelineSegment.TeeElbow,
        icon: PipeLineSegmentIcon[EPipelineSegment.TeeElbow],
        group: EPipelineGroupSegment.Pipe
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.TeeBranchBlanked}`),
        value: EPipelineSegment.TeeBranchBlanked,
        icon: PipeLineSegmentIcon[EPipelineSegment.TeeBranchBlanked],
        group: EPipelineGroupSegment.Pipe
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Swage45Degree}`),
        value: EPipelineSegment.Swage45Degree,
        icon: PipeLineSegmentIcon[EPipelineSegment.Swage45Degree],
        group: EPipelineGroupSegment.Pipe
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.SwageAbrupt}`),
        value: EPipelineSegment.SwageAbrupt,
        icon: PipeLineSegmentIcon[EPipelineSegment.SwageAbrupt],
        group: EPipelineGroupSegment.Pipe
    },
    /** Соединительные элементы трубопроводов **/
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Bend90_RD1}`),
        value: EPipelineSegment.Bend90_RD1,
        icon: PipeLineSegmentIcon[EPipelineSegment.Bend90_RD1],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Bend90_RD1_5}`),
        value: EPipelineSegment.Bend90_RD1_5,
        icon: PipeLineSegmentIcon[EPipelineSegment.Bend90_RD1_5],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Bend90_RD2}`),
        value: EPipelineSegment.Bend90_RD2,
        icon: PipeLineSegmentIcon[EPipelineSegment.Bend90_RD2],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Bend90_RD3}`),
        value: EPipelineSegment.Bend90_RD3,
        icon: PipeLineSegmentIcon[EPipelineSegment.Bend90_RD3],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Bend90_RD4}`),
        value: EPipelineSegment.Bend90_RD4,
        icon: PipeLineSegmentIcon[EPipelineSegment.Bend90_RD4],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Bend90_RD6}`),
        value: EPipelineSegment.Bend90_RD6,
        icon: PipeLineSegmentIcon[EPipelineSegment.Bend90_RD6],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Bend90_RD8}`),
        value: EPipelineSegment.Bend90_RD8,
        icon: PipeLineSegmentIcon[EPipelineSegment.Bend90_RD8],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Bend90_RD10}`),
        value: EPipelineSegment.Bend90_RD10,
        icon: PipeLineSegmentIcon[EPipelineSegment.Bend90_RD10],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Bend90_RD12}`),
        value: EPipelineSegment.Bend90_RD12,
        icon: PipeLineSegmentIcon[EPipelineSegment.Bend90_RD12],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Bend90_RD14}`),
        value: EPipelineSegment.Bend90_RD14,
        icon: PipeLineSegmentIcon[EPipelineSegment.Bend90_RD14],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Bend90_RD16}`),
        value: EPipelineSegment.Bend90_RD16,
        icon: PipeLineSegmentIcon[EPipelineSegment.Bend90_RD16],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Bend90_RD20}`),
        value: EPipelineSegment.Bend90_RD20,
        icon: PipeLineSegmentIcon[EPipelineSegment.Bend90_RD20],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Elbow45Long}`),
        value: EPipelineSegment.Elbow45Long,
        icon: PipeLineSegmentIcon[EPipelineSegment.Elbow45Long],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Elbow45Mitre}`),
        value: EPipelineSegment.Elbow45Mitre,
        icon: PipeLineSegmentIcon[EPipelineSegment.Elbow45Mitre],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Elbow45Std}`),
        value: EPipelineSegment.Elbow45Std,
        icon: PipeLineSegmentIcon[EPipelineSegment.Elbow45Std],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Elbow90Long}`),
        value: EPipelineSegment.Elbow90Long,
        icon: PipeLineSegmentIcon[EPipelineSegment.Elbow90Long],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Elbow90Mitre}`),
        value: EPipelineSegment.Elbow90Mitre,
        icon: PipeLineSegmentIcon[EPipelineSegment.Elbow90Mitre],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Elbow90Std}`),
        value: EPipelineSegment.Elbow90Std,
        icon: PipeLineSegmentIcon[EPipelineSegment.Elbow90Std],
        group: EPipelineGroupSegment.Bend
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.Degree180CloseReturn}`),
        value: EPipelineSegment.Degree180CloseReturn,
        icon: PipeLineSegmentIcon[EPipelineSegment.Degree180CloseReturn],
        group: EPipelineGroupSegment.Bend
    },
    /** Запорная и регулирующая арматура **/
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.AngleValve45Open}`),
        value: EPipelineSegment.AngleValve45Open,
        icon: PipeLineSegmentIcon[EPipelineSegment.AngleValve45Open],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.AngleValve90Open}`),
        value: EPipelineSegment.AngleValve90Open,
        icon: PipeLineSegmentIcon[EPipelineSegment.AngleValve90Open],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.AngleValveOpen}`),
        value: EPipelineSegment.AngleValveOpen,
        icon: PipeLineSegmentIcon[EPipelineSegment.AngleValveOpen],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.BallValveOpen}`),
        value: EPipelineSegment.BallValveOpen,
        icon: PipeLineSegmentIcon[EPipelineSegment.BallValveOpen],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.ButterflyValve2_8InOpen}`),
        value: EPipelineSegment.ButterflyValve2_8InOpen,
        icon: PipeLineSegmentIcon[EPipelineSegment.ButterflyValve2_8InOpen],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.ButterflyValve10_14InOpen}`),
        value: EPipelineSegment.ButterflyValve10_14InOpen,
        icon: PipeLineSegmentIcon[EPipelineSegment.ButterflyValve10_14InOpen],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.ButterflyValve16_24InOpen}`),
        value: EPipelineSegment.ButterflyValve16_24InOpen,
        icon: PipeLineSegmentIcon[EPipelineSegment.ButterflyValve16_24InOpen],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.ButterflyValveAngle5}`),
        value: EPipelineSegment.ButterflyValveAngle5,
        icon: PipeLineSegmentIcon[EPipelineSegment.ButterflyValveAngle5],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.ButterflyValveAngle10}`),
        value: EPipelineSegment.ButterflyValveAngle10,
        icon: PipeLineSegmentIcon[EPipelineSegment.ButterflyValveAngle10],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.ButterflyValveAngle20}`),
        value: EPipelineSegment.ButterflyValveAngle20,
        icon: PipeLineSegmentIcon[EPipelineSegment.ButterflyValveAngle20],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.ButterflyValveAngle40}`),
        value: EPipelineSegment.ButterflyValveAngle40,
        icon: PipeLineSegmentIcon[EPipelineSegment.ButterflyValveAngle40],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.ButterflyValveAngle60}`),
        value: EPipelineSegment.ButterflyValveAngle60,
        icon: PipeLineSegmentIcon[EPipelineSegment.ButterflyValveAngle60],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.CheckValveBall}`),
        value: EPipelineSegment.CheckValveBall,
        icon: PipeLineSegmentIcon[EPipelineSegment.CheckValveBall],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.CheckValveDisk}`),
        value: EPipelineSegment.CheckValveDisk,
        icon: PipeLineSegmentIcon[EPipelineSegment.CheckValveDisk],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.CheckValveLift}`),
        value: EPipelineSegment.CheckValveLift,
        icon: PipeLineSegmentIcon[EPipelineSegment.CheckValveLift],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.CheckValve45Lift}`),
        value: EPipelineSegment.CheckValve45Lift,
        icon: PipeLineSegmentIcon[EPipelineSegment.CheckValve45Lift],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.CheckValveSwing}`),
        value: EPipelineSegment.CheckValveSwing,
        icon: PipeLineSegmentIcon[EPipelineSegment.CheckValveSwing],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.GateValveCraneOpen}`),
        value: EPipelineSegment.GateValveCraneOpen,
        icon: PipeLineSegmentIcon[EPipelineSegment.GateValveCraneOpen],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.GateValveOneQuarter}`),
        value: EPipelineSegment.GateValveOneQuarter,
        icon: PipeLineSegmentIcon[EPipelineSegment.GateValveOneQuarter],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.GateValveHalf}`),
        value: EPipelineSegment.GateValveHalf,
        icon: PipeLineSegmentIcon[EPipelineSegment.GateValveHalf],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.GateValveThreeQuarter}`),
        value: EPipelineSegment.GateValveThreeQuarter,
        icon: PipeLineSegmentIcon[EPipelineSegment.GateValveThreeQuarter],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.GateValveOpen}`),
        value: EPipelineSegment.GateValveOpen,
        icon: PipeLineSegmentIcon[EPipelineSegment.GateValveOpen],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.GlobeValveCraneOpen}`),
        value: EPipelineSegment.GlobeValveCraneOpen,
        icon: PipeLineSegmentIcon[EPipelineSegment.GlobeValveCraneOpen],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.GlobeValveHalf}`),
        value: EPipelineSegment.GlobeValveHalf,
        icon: PipeLineSegmentIcon[EPipelineSegment.GlobeValveHalf],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.GlobeValveOpen}`),
        value: EPipelineSegment.GlobeValveOpen,
        icon: PipeLineSegmentIcon[EPipelineSegment.GlobeValveOpen],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.PlugCockAngle5}`),
        value: EPipelineSegment.PlugCockAngle5,
        icon: PipeLineSegmentIcon[EPipelineSegment.PlugCockAngle5],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.PlugCockAngle10}`),
        value: EPipelineSegment.PlugCockAngle10,
        icon: PipeLineSegmentIcon[EPipelineSegment.PlugCockAngle10],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.PlugCockAngle20}`),
        value: EPipelineSegment.PlugCockAngle20,
        icon: PipeLineSegmentIcon[EPipelineSegment.PlugCockAngle20],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.PlugCockAngle40}`),
        value: EPipelineSegment.PlugCockAngle40,
        icon: PipeLineSegmentIcon[EPipelineSegment.PlugCockAngle40],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.PlugCockAngle60}`),
        value: EPipelineSegment.PlugCockAngle60,
        icon: PipeLineSegmentIcon[EPipelineSegment.PlugCockAngle60],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.PlugCockOpen}`),
        value: EPipelineSegment.PlugCockOpen,
        icon: PipeLineSegmentIcon[EPipelineSegment.PlugCockOpen],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.BlowoffValveOpen}`),
        value: EPipelineSegment.BlowoffValveOpen,
        icon: PipeLineSegmentIcon[EPipelineSegment.BlowoffValveOpen],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.DiaphragmValveOneQuarter}`),
        value: EPipelineSegment.DiaphragmValveOneQuarter,
        icon: PipeLineSegmentIcon[EPipelineSegment.DiaphragmValveOneQuarter],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.DiaphragmValveHalf}`),
        value: EPipelineSegment.DiaphragmValveHalf,
        icon: PipeLineSegmentIcon[EPipelineSegment.DiaphragmValveHalf],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.DiaphragmValveThreeQuarter}`),
        value: EPipelineSegment.DiaphragmValveThreeQuarter,
        icon: PipeLineSegmentIcon[EPipelineSegment.DiaphragmValveThreeQuarter],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.DiaphragmValveOpen}`),
        value: EPipelineSegment.DiaphragmValveOpen,
        icon: PipeLineSegmentIcon[EPipelineSegment.DiaphragmValveOpen],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.FootValve}`),
        value: EPipelineSegment.FootValve,
        icon: PipeLineSegmentIcon[EPipelineSegment.FootValve],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.FootValveHingedDisk}`),
        value: EPipelineSegment.FootValveHingedDisk,
        icon: PipeLineSegmentIcon[EPipelineSegment.FootValveHingedDisk],
        group: EPipelineGroupSegment.Valve
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.FootValvePoppetDisk}`),
        value: EPipelineSegment.FootValvePoppetDisk,
        icon: PipeLineSegmentIcon[EPipelineSegment.FootValvePoppetDisk],
        group: EPipelineGroupSegment.Valve
    },
    /** Приборы учёта и контроля **/
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.WaterMeterDisk}`),
        value: EPipelineSegment.WaterMeterDisk,
        icon: PipeLineSegmentIcon[EPipelineSegment.WaterMeterDisk],
        group: EPipelineGroupSegment.WaterMeter
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.WaterMeterPiston}`),
        value: EPipelineSegment.WaterMeterPiston,
        icon: PipeLineSegmentIcon[EPipelineSegment.WaterMeterPiston],
        group: EPipelineGroupSegment.WaterMeter
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.WaterMeterRotary}`),
        value: EPipelineSegment.WaterMeterRotary,
        icon: PipeLineSegmentIcon[EPipelineSegment.WaterMeterRotary],
        group: EPipelineGroupSegment.WaterMeter
    },
    {
        label: i18n.t(`enum.pipelineSegment.${EPipelineSegment.WaterMeterTurbine}`),
        value: EPipelineSegment.WaterMeterTurbine,
        icon: PipeLineSegmentIcon[EPipelineSegment.WaterMeterTurbine],
        group: EPipelineGroupSegment.WaterMeter
    }
];
//# sourceMappingURL=PipelineConfigJsField.constants.js.map